<template>
  <div>
    <h1 class="page-header">{{ $t('payFixedIncentiveBonus.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.employee ? record.employee.employee_name_en : '' }}</td>
            <td>{{ record.incentive_bonus_item ? record.incentive_bonus_item.inc_bonus_item : '' }}</td>
            <td>{{ record.inc_bonus }}</td>
            <td>{{ record.effectve_date }}</td>
            <td>{{ record.expiry_date }}</td>
            <td>{{ record.description }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="$t('tooltip.edit')" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'pay-fixed-incentive-bonus',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payFixedIncentiveBonus', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.payFixedIncentiveBonus.search
      },
      set(newValue) {
        this.$store.commit('hr/payFixedIncentiveBonus/SET_SEARCH', newValue)
        this.$store.commit('hr/payFixedIncentiveBonus/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payFixedIncentiveBonus.employeeId'),
          sortKey: 'employee.employee_name_en'
        },
        {
          name: this.$t('payFixedIncentiveBonus.incBonusId'),
          sortKey: 'incentive_bonus_item.inc_bonus_item'
        },
        {
          name: this.$t('payFixedIncentiveBonus.incBonus'),
          sortKey: 'inc_bonus'
        },
        {
          name: this.$t('payFixedIncentiveBonus.effectveDate'),
          sortKey: 'effectve_date'
        },
        {
          name: this.$t('payFixedIncentiveBonus.expiryDate'),
          sortKey: 'expiry_date'
        },
        {
          name: this.$t('payFixedIncentiveBonus.description'),
          sortKey: 'description'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payFixedIncentiveBonus/fetch', { include: 'employee,incentive_bonus_item', ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/payFixedIncentiveBonus/destroy', record.record_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payFixedIncentiveBonus/RESET_STATE')
    next()
  }
}
</script>
